export const AUS_TIMEZONE = [
  {
    label: 'Australian Eastern Standard Time (AEST)',
    city: 'Brisbane, Sydney, Melbourne, Hobart, Canberra',
    utc: 'UTC+10:00',
  },
  {
    label: 'Australian Central Standard Time (ACST)',
    city: 'Adelaide, Darwin, Broken Hill',
    utc: 'UTC+09:30',
  },
  {
    label: 'Australian Western Standard Time (AWST)',
    city: 'Perth',
    utc: 'UTC+08:00',
  },
  {
    label: 'Norfolk Island Standard Time (NFT)',
    city: 'Kingston',
    utc: 'UTC+11:00',
  },
];

export const AUS_TIMEZONE_DST = [
  {
    label: 'Australian Eastern Standard Time (AEST)',
    city: 'Brisbane',
    utc: 'UTC+10:00',
  },
  {
    label: 'Australian Eastern Daylight Time (AEDT)',
    city: 'Sydney, Melbourne, Hobart, Canberra',
    utc: 'UTC+11:00',
  },
  {
    label: 'Australian Central Daylight Time (ACDT)',
    city: 'Adelaide, Broken Hill',
    utc: 'UTC+10:30',
  },
  {
    label: 'Australian Central Standard Time (ACST)',
    city: 'Darwin',
    utc: 'UTC+09:30',
  },
  {
    label: 'Australian Western Standard Time (AWST)',
    city: 'Perth',
    utc: 'UTC+08:00',
  },
  {
    label: 'Norfolk Island Daylight Time (NFDT)',
    city: 'Kingston',
    utc: 'UTC+12:00',
  },
];

export const AUS_TIMEZONE_LIST_ONLY_LABEL = [
  'Australia/Perth',
  'Australia/Eucla',
  'Australia/Adelaide',
  'Australia/Broken_Hill',
  'Australia/Darwin',
  'Australia/Brisbane',
  'Australia/Currie',
  'Australia/Hobart',
  'Australia/Lindeman',
  'Australia/Melbourne',
  'Australia/Sydney',
  'Australia/Lord_Howe',
  'Antarctica/Macquarie',
];

// Selectable zones whose offsets other zones share, labelled by the zone rather than the
// offset: Lord Howe's +11:00 is not AEDT and its +10:30 is not ACDT.
export const ZONE_OFFSET_TO_TIMEZONE_ABBREVIATION = {
  'Australia/Lord_Howe': { '+10:30': 'LHST', '+11:00': 'LHDT' },
};

export const MELBOURNE_TIMEZONE = 'Australia/Melbourne';
